import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { motion } from "framer-motion";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import image1 from "../../Assets/Images/slider1.webp";
import image2 from "../../Assets/Images/slider2.webp";
import image3 from "../../Assets/Images/slider3.jpeg";

const Slider = () => {
  const images = [
    {
      src: image1,
    },
    {
      src: image2,
    },
    {
      src: image3,
    },
  ];

  return (
    <div className="relative w-full h-[130px] md:h-[320px] lg:h-[400px] xl:h-[600px]">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={0}
        slidesPerView={1}
        navigation={{
          prevEl: ".swiper-button-prev-custom",
          nextEl: ".swiper-button-next-custom",
        }}
        pagination={{
          clickable: true,
          el: ".swiper-pagination-custom",
        }}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        loop={true}
        className="w-full h-full"
      >
        {images.map((image, index) => (
          <SwiperSlide key={index}>
            <motion.div
              className="relative w-full h-full"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, ease: "easeInOut" }}
            >
              <img
                src={image.src}
                alt={`Slide ${index + 1}`}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 flex flex-col justify-center items-center text-white text-center p-4">
                <motion.h2
                  initial={{ opacity: 0, y: -50 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.9, ease: "easeInOut" }}
                  className="text-lg sm:text-2xl md:text-3xl lg:text-[40px] font-bold xl:w-[45%] lg:w-[60%] md:w-[80%] m-auto tracking-wider text-[#27D458]"
                ></motion.h2>

                <motion.p
                  initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 1.2, ease: "easeInOut" }}
                  className="w-[90%] sm:w-[80%] md:w-[70%] m-auto mt-2 sm:mt-4 md:mt-6 text-sm sm:text-base md:text-[16px] tracking-wide"
                >
                  {image.text}
                </motion.p>
              </div>
            </motion.div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Custom Navigation Buttons */}
      <motion.button
        className="swiper-button-prev-custom absolute top-1/2 left-2 transform -translate-y-1/2 z-10 focus:outline-none text-white hover:text-orange-500 font-bold cursor-pointer bg-black bg-opacity-30 rounded-full p-2 transition-colors duration-300"
        whileHover={{ scale: 1.1 }}
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
          <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
        </svg>
      </motion.button>

      <motion.button
        className="swiper-button-next-custom absolute top-1/2 right-2 transform -translate-y-1/2 z-10 focus:outline-none text-white hover:text-orange-500 font-bold cursor-pointer bg-black bg-opacity-30 rounded-full p-2 transition-colors duration-300"
        whileHover={{ scale: 1.1 }}
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
          <path d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z" />
        </svg>
      </motion.button>

      {/* Custom Pagination Dots */}
      <div className="swiper-pagination-custom absolute inset-x-0 bottom-2 sm:bottom-4 flex justify-center space-x-2 z-10">
        {/* Swiper will automatically populate this with dots */}
      </div>

      {/* Custom CSS for Swiper pagination */}
      <style jsx>{`
        .swiper-pagination-custom .swiper-pagination-bullet {
          width: 12px;
          height: 12px;
          background: rgba(255, 255, 255, 0.5);
          opacity: 1;
          border-radius: 50%;
          transition: all 0.3s ease;
        }

        .swiper-pagination-custom .swiper-pagination-bullet-active {
          background: #f97316;
          transform: scale(1.2);
        }
      `}</style>
    </div>
  );
};

export default Slider;
